// extracted by mini-css-extract-plugin
module.exports = {"container":"media_container__8IkV8","image":"media_image__PeLKe","imageFull":"media_imageFull__3KwwE"};